import React from 'react';
import { Link } from 'react-router-dom';

// react component for creating beautiful carousel
import Carousel from 'react-slick';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

// core components
import carouselStyle from 'assets/jss/material-dashboard-pro-react/views/componentsSections/carouselStyle.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

const SectionCarouselDesktop = ({ list, type, classes }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Carousel
      style={{ borderRadius: '15px', marginLeft: '-25px' }}
      {...settings}
      id="home"
    >
      {list.map((data, index) => (
        <GridItem xs={12} key={index}>
          <div>
            <Link
              to={{
                pathname: `/swipe/collection/${type}/${index}`,
              }}
            >
              <img
                style={{
                  padding: '1px',
                  height: '100%',
                  borderRadius: '15px',
                }}
                src={data.imgsrc}
                alt="Slide1"
                className="slick-image"
              />
              <PlayCircleFilledIcon
                style={{
                  opacity: '.85',
                  zIndex: '999',
                  position: 'absolute',
                  margin: '30% 0px 0px 44%',
                  color: 'white',
                  fontSize: '60px',
                }}
              />
            </Link>
            <br />
            <div style={{ textAlign: 'left' }}>
              <Link
                to={{
                  pathname: `/swipe/collection/${type}/${index}`,
                }}
              >
                <p
                  style={{
                    fontWeight: '400',
                    color: 'black',
                    margin: '10px 0px 0px 0px',
                  }}
                  className={classes.description}
                >
                  {data.title}
                </p>
              </Link>
              <Link to={`/artists/`}>
                <p
                  style={{ fontWeight: '600', color: 'black' }}
                  className={classes.description}
                >
                  <b>{data.artist}</b>
                </p>
              </Link>
            </div>
          </div>
        </GridItem>
      ))}
    </Carousel>
  );
};

export default withStyles(carouselStyle)(SectionCarouselDesktop);
